export default __webpack_public_path__ + "static/media/null.eaa2fc04.jpg";